import React from 'react'
import { Helmet } from 'react-helmet'
import MegaMenu from '../components/MegaMenu/MegaMenu'
import ServicesPageBanner from '../components/services-page-banner/ServicesPageBanner'
import NewTestimonials from '../components/new-testimonials/NewTestimonials'
import WhyChooseUs from '../components/why-choose-us/WhyChooseUs'
import NewCaseStudySection from '../components/new-case-study-section/NewCaseStudySection'
import HireCombinationSection from '../components/hire-combination-sectiono/HireCombinationSection'
import HirePageSteps from '../components/hire-page-steps/HirePageSteps'
import CoverTheStack from '../components/coverthestack/CoverTheStack'
import TrendsInsights from '../components/trends-n-insights/TrendsInsights'
import SecondFaq from '../components/secondFaq/SecondFaq'
import SoftwareCompanyCta from '../components/software-company-cta/SoftwareCompanyCta'
import { hireReactNativePageContent } from '../data/hire-react-native-developer'
import TrustedPartner from '../components/trustedPartners/TrustedPartner'
import OurServices from '../components/our-services/OurServices'
import Footer from '../components/footer/Footer'
import SimpleModels from '../components/simpleEngagementModels'
import ChallengeSection from '../components/challenge-section/ChallengeSection'
import HirePageSolutionSection from '../components/hire-page-solution-section/HirePageSolutionSection'

const HireReactNative = () => {
    return (
        <>
            <Helmet>
                <title>Hire React Native Developers | Next‑Gen AI Mobile App Engineers</title>
                <meta name="description" content="Hire expert React Native developers from Bitsclan to build next-gen AI-powered mobile apps. Our expert react developers specialize in creating cross-platform app solutions for Android and iOS, integrating intelligent chatbots, and smart automation to deliver seamless user experiences." />
            </Helmet>

            <MegaMenu />

            <ServicesPageBanner
                shortHeading={hireReactNativePageContent?.mainBanner?.shortHeading}
                mainHeading={hireReactNativePageContent?.mainBanner?.mainHeading}
                description={hireReactNativePageContent?.mainBanner?.content}
            />
            <TrustedPartner heading={"Trusted & Partnered by Businesses Worldwide to Build High-Performance React Native Solutions"} />

            <OurServices
                shortHeading={hireReactNativePageContent?.reactNativeExpertise?.shortHeading}
                mainHeading={hireReactNativePageContent?.reactNativeExpertise?.heading}
                description={hireReactNativePageContent?.reactNativeExpertise?.description}
                servicesCardsData={hireReactNativePageContent?.reactNativeExpertise?.servicesData}
                buttonText="Start Your React Native Project"
            />

            <NewTestimonials
                shortHeading=" Some of Our Happy Clients"
                mainHeading="Trusted Partnerships Proven <span>React Native</span> Engineering Excellence"
                description="We take pride in our React Native app development services, earning positive feedback from clients who value our dedication, quality, & reliable results. Their satisfaction inspires us to deliver exceptional mobile solutions every time."
                content={hireReactNativePageContent?.testimonials}
            />

            <NewCaseStudySection
                shortHeading="Our Clients’ Journey"
                heading="Driving Business Growth Through React Native Innovation"
                description="Explore how our React Native engineers help businesses modernize their mobile presence with cross-platform efficiency, cost-effective scaling, and consistent UX empowering growth and long-term success."
            />

            <HireCombinationSection
                shortHeading={hireReactNativePageContent?.techCombinations?.shortHeading}
                combinations={hireReactNativePageContent?.techCombinations.combinations}
                heading={hireReactNativePageContent?.techCombinations.heading}
                description={hireReactNativePageContent?.techCombinations.description}
            />

            <SimpleModels content={hireReactNativePageContent?.hireReactNativeEngagementModeContent} />

            <CoverTheStack
                shortHeading={hireReactNativePageContent?.coverTheStack?.shortHeading}
                whereStart={hireReactNativePageContent?.coverTheStack?.whereStart}
                mainHeading={hireReactNativePageContent?.coverTheStack?.mainHeading}
                subHeading={hireReactNativePageContent?.coverTheStack?.subHeading}
                tabs={hireReactNativePageContent?.coverTheStack?.tabs}
                tabItems={hireReactNativePageContent?.coverTheStack?.tabItems}
            />

            <HirePageSteps
                buttonText={hireReactNativePageContent?.hireSteps.btnText}
                heading={hireReactNativePageContent?.hireSteps.heading}
                subHeading={hireReactNativePageContent?.hireSteps.subHeading}
                steps={hireReactNativePageContent?.hireSteps.steps}
            />

            <ChallengeSection
                mainHeading={hireReactNativePageContent?.challengesSolutions?.shortHeading}
                description={hireReactNativePageContent?.challengesSolutions?.mainHeading}
                content={hireReactNativePageContent?.challengesSolutions?.challenges}
            />

            <HirePageSolutionSection
                shortHeading="React Native Solutions We Build"
                mainHeading="How We Solve React Native Development & Team Scaling Challenges"
                description="We streamline how businesses build, scale, and manage React Native development teams, addressing every technical and operational barrier from onboarding to deployment. Our process ensures faster app delivery, smoother performance, and a unified experience across both Android and iOS platforms."
                content={hireReactNativePageContent?.reactNativeBenefits}
            />

            <WhyChooseUs
                shortHeading={hireReactNativePageContent?.whyChooseUs?.shortHeading}
                greenHeading={hireReactNativePageContent?.whyChooseUs?.greenHeading}
                heading={hireReactNativePageContent?.whyChooseUs?.mainHeading}
                content={hireReactNativePageContent?.whyChooseUs?.description}
                stats={hireReactNativePageContent?.whyChooseUs?.statsData}
            />

            <TrendsInsights heading="Expert Insights to Accelerate Your React Native App Success" description="Our React Native specialists reveal practical techniques, frameworks, & trending solutions for mobile app development. We guide businesses & teams to streamline processes, enhance app performance, & deliver outstanding user experiences across iOS & android platforms with React Native’s versatile capabilities." specificClass="mobile-dev-page" category="all" />

            <SecondFaq
                specificClass="mobile-dev-page"
                faqs={hireReactNativePageContent?.faqSection.faqData}
                mainHeading={hireReactNativePageContent?.faqSection.mainHeading}
                subHeading={hireReactNativePageContent?.faqSection.subHeading}
            />

            <SoftwareCompanyCta content={hireReactNativePageContent?.comapnyCtaContent} />

            <Footer />
        </>
    )
}

export default HireReactNative